import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription, forkJoin } from "rxjs";
import { AppService } from "src/app/app.service";
import {
  CompanyNavPageDataService,
  NAV_LOG_ACTION_FEATURES,
  NAV_PAGE,
} from "../company-nav-page-data.service";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/state/app.state";
import { DeleteDpParams } from "src/app/store/actions/global-subheader.actions";

@Component({
  selector: "app-company-nav-page",
  templateUrl: "./company-nav-page.component.html",
  styleUrls: ["./company-nav-page.component.scss"],
  host: { class: "company-nav-page-component" },
})
export class CompanyNavPageComponent {
  currentTicker;
  dataSettings = {
    currency: "Base",
    view_by: ["values"],
    revision: "",
    customCC: [],
    showHighLow: true,
    keyChanged: "",
  };
  routeParamSubscriber: Subscription;
  metaInfo: any;
  metaLoading: boolean = true;
  savedSettings = {
    keyChanged: "",
  };
  constructor(
    private route: ActivatedRoute,
    private appService: AppService,
    private store: Store<AppState>,
    private dataService: CompanyNavPageDataService,
  ) {}
  ngOnInit() {
    this.routeParamSubscriber = this.route.params.subscribe((paramData) => {
      this.currentTicker = paramData.ticker
        ? paramData.ticker.toUpperCase()
        : undefined;

      this.appService.logUserAction(
        {},
        this.currentTicker,
        "",
        NAV_LOG_ACTION_FEATURES.visitPage,
        {},
        "",
        NAV_PAGE,
      );
      this.getMetaInfo();
    });
  }
  gridDataSettingsChanged($event) {
    this.store.dispatch(new DeleteDpParams());
    if ($event.keyChanged === "currency") {
      this.metaLoading = true;

      const currency = $event.currency === "" ? "Base" : $event.currency;
      this.dataSettings.currency = $event.currency;
      this.dataSettings.keyChanged = $event.keyChanged;

      this.dataService
        .saveSettings(this.dataSettings, this.currentTicker)
        .subscribe(() => {
          this.dataService
            .getMetaInfo(this.currentTicker, currency)
            .subscribe((response) => {
              const oldSourcesInfo = this.metaInfo.sources_info.map(
                (val) => val,
              );

              this.metaInfo = {
                ...response.data,
                sourceDocMapping: response.data.sources_info,
                sources_info: [...oldSourcesInfo],
                status: "success",
                currencyChanged: true,
                currency: $event.currency,
              };
              this.metaLoading = false;
            });
        });
    } else {
      this.dataSettings = { ...$event };
      this.dataService
        .saveSettings(this.dataSettings, this.currentTicker)
        .subscribe(() => {
          this.dataSettings = { ...$event };
        });
    }
    this.logGridSettingsChanged($event);
  }

  updateSourcesInfo($event) {
    const { view_by, rev_date, masterparameter_dict, defaultSource } = $event;
    this.metaLoading = true;
    const apiCalls = [
      this.dataService.getSourcesInfo(
        this.currentTicker,
        view_by,
        rev_date,
        masterparameter_dict,
        defaultSource,
      ),
      this.dataService.getSourcesList(this.currentTicker),
    ];

    forkJoin(apiCalls).subscribe((res) => {
      if (res[0]["status"] === "success" && res[1]["status"] === "success") {
        this.metaInfo = {
          ...this.metaInfo,
          sourceDocMapping: res[0]["sources_info"],
          sources_info: res[1]["data"],
          user_settings: {
            ...this.metaInfo.user_settings,
            view_by: [view_by],
            revision: rev_date,
          },
          makeDataCall: true,
          source_updated: true,
        };
        this.metaInfo["column_order"].forEach((colId) => {
          this.metaInfo["columns_info"][colId]["source_list"] =
            res[0]["columns_info"][colId]["source_list"];
        });
        this.metaLoading = false;
      }
    });
  }

  getMetaInfo() {
    this.metaLoading = true;
    const apiCalls = [
      this.dataService.getMetaInfo(this.currentTicker),
      this.dataService.getSourcesList(this.currentTicker),
    ];
    forkJoin(apiCalls).subscribe(
      (response) => {
        if (
          response[0].status === "success" &&
          response[1].status === "success"
        ) {
          this.metaInfo = {
            ...response[0].data,
            sourceDocMapping: response[0].data.sources_info,
            sources_info: response[1].data,
          };
          this.metaInfo.status = "success";
        } else {
          this.metaInfo = {
            status: "error",
          };
        }
        if (
          this.metaInfo.user_settings &&
          this.metaInfo.user_settings.keyChanged
        ) {
          this.dataSettings = {
            ...this.metaInfo.user_settings,
          };
        }

        this.metaLoading = false;
      },
      () => {
        this.metaLoading = false;
        this.metaInfo = {
          status: "error",
        };
      },
    );
    // this.dataService.getMetaInfo(this.currentTicker).subscribe((resp) => {
    //   this.metaInfo = resp;
    // });
    // this.dataService.getSourcesList(this.currentTicker).subscribe((resp:any)=>{

    // })
  }
  logGridSettingsChanged(settings) {
    let feature = "";
    let extras = {};
    switch (settings.keyChanged) {
      case "revision":
        feature = NAV_LOG_ACTION_FEATURES.revisionSelection;
        extras = {
          view_by: settings.view_by,
          revision: settings.revision,
        };
        break;
      case "customCC":
        feature = NAV_LOG_ACTION_FEATURES.customConsensusSelection;
        extras = {
          customCC: settings.customCC,
        };
        break;
      case "currency":
        feature = NAV_LOG_ACTION_FEATURES.currencySelection;
        extras = {
          currency: settings.currency,
        };
        break;
      case "highLow":
        feature = NAV_LOG_ACTION_FEATURES.highLow;
        extras = {
          showHighLow: settings.showHighLow,
        };
        break;
      default:
        break;
    }
    if (feature !== "") {
      this.appService.logUserAction(
        {},
        this.currentTicker,
        "",
        feature,
        extras,
        "",
        NAV_PAGE,
      );
    }
  }
}
